"use strict";

var _toConsumableArray = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DependencyCollection = void 0;

var object_type_1 = require("./object-type");

var dependency_life_time_1 = require("./dependency-life-time");

var dependency_descriptor_1 = require("./dependency-descriptor");

var dependency_container_1 = require("./dependency-container");

var DependencyCollection = /*#__PURE__*/function () {
  function DependencyCollection() {
    _classCallCheck(this, DependencyCollection);

    this._registeredTypes = new Map();
    this.register(dependency_container_1.DependencyContainer, dependency_life_time_1.DependencyLifeTime.Transient);
  }

  _createClass(DependencyCollection, [{
    key: "register",
    value: function register(objectType, lifeTime, dependencies, instance) {
      if (this.contains(objectType)) throw new Error("The type ".concat(object_type_1.getObjectTypeName(objectType), " is already registered."));
      if (instance && lifeTime !== dependency_life_time_1.DependencyLifeTime.Singleton) throw new Error("Only the singletons can be registered with an existing instance.");

      this._registeredTypes.set(objectType, new dependency_descriptor_1.DependencyDescriptor(lifeTime || dependency_life_time_1.DependencyLifeTime.Transient, dependencies || [], instance || null));
    }
  }, {
    key: "registerTransient",
    value: function registerTransient(objectType, dependencies) {
      this.register(objectType, dependency_life_time_1.DependencyLifeTime.Transient, dependencies);
    }
  }, {
    key: "registerScoped",
    value: function registerScoped(objectType, dependencies) {
      this.register(objectType, dependency_life_time_1.DependencyLifeTime.Scoped, dependencies);
    }
  }, {
    key: "registerSingleton",
    value: function registerSingleton(objectType, dependencies, instance) {
      this.register(objectType, dependency_life_time_1.DependencyLifeTime.Singleton, dependencies, instance);
    }
  }, {
    key: "get",
    value: function get(objectType) {
      if (!this._registeredTypes.has(objectType)) throw new Error("The type ".concat(object_type_1.getObjectTypeName(objectType), " is not registered."));
      return this._registeredTypes.get(objectType);
    }
  }, {
    key: "contains",
    value: function contains(objectType) {
      return this._registeredTypes.has(objectType);
    }
  }, {
    key: "buildContainer",
    value: function buildContainer() {
      var validate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (validate) {
        var errors = '';

        var _iterator = _createForOfIteratorHelper(this._registeredTypes.keys()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var registeredType = _step.value;

            try {
              this.validateCircularDependency(registeredType);
              this.validateDependencyRegistration(registeredType);
              this.validateScopedOnSingletons(registeredType);
            } catch (e) {
              errors += " - ".concat(e.message, "\n");
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (errors.length > 0) {
          throw new Error("Errors found on the dependency configuration:\n" + errors);
        }
      }

      return dependency_container_1.DependencyContainer.createFromCollection(this, "root");
    }
  }, {
    key: "validateDependencyRegistration",
    value: function validateDependencyRegistration(objectType) {
      var descriptor = this.get(objectType);

      var _iterator2 = _createForOfIteratorHelper(descriptor.dependencies),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var dependencyType = _step2.value;

          if (!this.contains(dependencyType)) {
            throw new Error("The type '".concat(object_type_1.getObjectTypeName(objectType), "' depends on the type '").concat(object_type_1.getObjectTypeName(dependencyType), "' but is not registered."));
          }

          this.validateDependencyRegistration(dependencyType);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "validateCircularDependency",
    value: function validateCircularDependency(objectType, hierarchy) {
      var _this = this;

      if (!hierarchy) hierarchy = [];
      var descriptor = this.get(objectType);
      var dependencies = descriptor.dependencies;

      var _iterator3 = _createForOfIteratorHelper(dependencies),
          _step3;

      try {
        var _loop = function _loop() {
          var dependencyType = _step3.value;
          if (!_this.contains(dependencyType)) return "continue";

          if (hierarchy.find(function (x) {
            return x === dependencyType;
          })) {
            throw new Error("Circular dependency found in service type '".concat(object_type_1.getObjectTypeName(hierarchy[0]), "': ").concat(hierarchy.map(function (x) {
              return object_type_1.getObjectTypeName(x);
            }).join(" -> "), " -> ").concat(object_type_1.getObjectTypeName(dependencyType), "."));
          }

          var newHierarchy = _toConsumableArray(hierarchy);

          newHierarchy.push(dependencyType);

          _this.validateCircularDependency(dependencyType, newHierarchy);
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "validateScopedOnSingletons",
    value: function validateScopedOnSingletons(objectType) {
      var descriptor = this.get(objectType);

      var _iterator4 = _createForOfIteratorHelper(descriptor.dependencies),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var dependencyType = _step4.value;
          var dependencyDescriptor = this.get(dependencyType);

          if (descriptor.lifeTime === dependency_life_time_1.DependencyLifeTime.Singleton && dependencyDescriptor.lifeTime === dependency_life_time_1.DependencyLifeTime.Scoped) {
            throw new Error("Cannot consume scoped type '".concat(object_type_1.getObjectTypeName(dependencyType), "' from singleton '").concat(object_type_1.getObjectTypeName(objectType), "'."));
          }

          this.validateScopedOnSingletons(dependencyType);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }], [{
    key: "globalCollection",
    get: function get() {
      if (!this._globalCollection) this._globalCollection = new DependencyCollection();
      return this._globalCollection;
    }
  }]);

  return DependencyCollection;
}();

exports.DependencyCollection = DependencyCollection;